import { Flowmap as _Flowmap, Mesh, Triangle, Program, Vec2, Color } from 'ogl'

/* Extended Flowmap to have custom shader
---------------------------------------------------------------------------------------------------- */

export default class Flowmap extends _Flowmap {

    constructor(gl, props = {}) {
        const {
            falloff = 0.15,
            alpha = 1,
            dissipation = 0.02,
            noiseTexture = null,
            color = null,
        } = props

        super(gl, props)



        this.prevMouse = new Vec2()
        this.mesh.geometry.remove()
        this.mesh.program.remove()


        this.mesh = new Mesh(gl, {
            geometry: new Triangle(gl),
            program: new Program(gl, {
                vertex,
                fragment,

                depthTest: false,
                uniforms: {
                    tMap: this.uniform,

                    uFalloff: { value: falloff },
                    uAlpha: { value: alpha },
                    uDissipation: { value: dissipation },

                    // User needs to update these
                    uAspect: { value: 1 },
                    uColor: { value: new Color(color) },
                    uMouse: { value: this.mouse },
                    tNoise: { value: noiseTexture },
                    uPrevMouse: { value: this.prevMouse },
                    uVelocity: { value: this.velocity },
                    uIsDown: { value: false },
                    uTime: { value: 0 },
                },
            }),
        })
    }


    setSize(width, height) {
        this.mask.read.setSize(width, height)
        this.mask.write.setSize(width, height)
    }


    // Getters / Setters

    set isDown(v) {
        this.mesh.program.uniforms.uIsDown.value = v
    }

    get isDown() {
        return this.mesh.program.uniforms.uIsDown.value
    }

    set time(v) {
        this.mesh.program.uniforms.uTime.value = v
    }

    get time() {
        return this.mesh.program.uniforms.uTime.value
    }

    set dissipation(v) {
        this.mesh.program.uniforms.uDissipation.value = v
    }

    get dissipation() {
        return this.mesh.program.uniforms.uDissipation.value
    }

    set falloff(v) {
        this.mesh.program.uniforms.uFalloff.value = v
    }

    get falloff() {
        return this.mesh.program.uniforms.uFalloff.value
    }

}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */

const vertex = /* glsl */ `
    attribute vec2 uv;
    attribute vec2 position;
    varying vec2 vUv;

    void main() {
        vUv = uv;
        gl_Position = vec4(position, 0, 1);
    }
`

const fragment = /* glsl */ `
    precision highp float;
    #define saturate(v) clamp(v, 0., 1.)

    uniform sampler2D tNoise;
    uniform sampler2D tMap;
    uniform float uFalloff;
    uniform float uAlpha;
    uniform float uDissipation;

    uniform float uAspect;
    uniform float uTime;
    uniform bool uIsDown;

    uniform vec2 uMouse;
    uniform vec3 uColor;
    uniform vec2 uPrevMouse;
    uniform vec2 uVelocity;
    varying vec2 vUv;

    float sdLine( vec2 p, vec2 a, vec2 b, float aspect){
        vec2 _a = a * 0.5 + 0.5;
        vec2 _b = b * 0.5 + 0.5;
        vec2 pa = p - _a, ba = _b - _a;
        vec2 as = vec2(aspect, 1.);

        pa *= as;
        ba *= as;

        float h = clamp( dot(pa,ba)/dot(ba,ba), 0.0, 1.0 );

        return length( pa - ba*h );
    }



    void main() {
        float n = texture2D(tNoise, (vUv + vec2(uTime)) * vec2(uAspect, 1.) * 16.).r;


        vec4 color = max(vec4(0), texture2D(tMap, vUv) - (uDissipation * n));


        float cursor = sdLine(vUv, uPrevMouse, uMouse, uAspect);
        float distanceFromCursor = saturate(0.3 - length((uMouse * 0.5 + 0.5 - vUv) * vec2(uAspect, 1.)));

        if (uIsDown) {
            float lenVel = smoothstep(1., 0.3, length(uVelocity));
            float falloff = pow(smoothstep(uFalloff * lenVel, 0., cursor), 2.) * uAlpha;
            color.rgb += falloff * n;
            color.rgb = min(color.rgb, vec3(1));
        } else {
        }
        // float fadeOut = smoothstep(0.95, .95, color.a);
        // color *= fadeOut; //* (1. - uDissipation);

        color.rgb = vec3((color.r + color.g + color.b) / 3.);

        // color = vec4((color.r + color.g + color.b) / 3.);

        gl_FragColor = color;
    }
`
